<template>
  <li class="tutorials-list-row">
    <button
      type="button"
      class="tutorials-list-row__button"
      :disabled="disabled"
      @click="emit('click')"
    >
      <span class="tutorials-list-row__body">
        <span class="tutorials-list-row__name">{{ name }}</span>
        <span
          v-if="secondaryText"
          class="tutorials-list-row__secondary"
        >
          {{ secondaryText }}
        </span>
        <span
          v-if="trailingText"
          class="tutorials-list-row__trailing"
        >
          {{ trailingText }}
        </span>
      </span>
      <ui-icon
        type="round"
        class="tutorials-list-row__chevron"
      >
        chevron_right
      </ui-icon>
    </button>
  </li>
</template>

<script setup>
defineProps({
  name: {
    type: String,
    required: true,
  },
  secondaryText: {
    type: String,
    default: '',
  },
  trailingText: {
    type: String,
    default: '',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['click']);
</script>

<style lang="scss" scoped>
.tutorials-list-row {
  &:last-child &__button {
    border-bottom: none;
  }

  &__button {
    @apply tw-flex tw-w-full tw-items-center tw-gap-3 tw-border-0 tw-border-b tw-bg-transparent tw-px-4 tw-py-6 tw-text-left;
    @apply tw-cursor-pointer;
    border-bottom: 1px solid theme('colors.border.base');
    transition: background-color 0.15s ease-in-out;

    &:hover:not(:disabled) {
      @apply tw-bg-grey-light;
    }

    &:disabled {
      @apply tw-cursor-not-allowed tw-opacity-50;
    }
  }

  &__body {
    @apply tw-flex tw-min-w-0 tw-flex-1 tw-flex-col tw-gap-0.5;
  }

  &__name {
    @apply tw-text-xl tw-font-medium tw-text-black-870;
  }

  &__secondary {
    @apply tw-pb-3 tw-text-base tw-font-regular tw-text-black-500;
  }

  &__trailing {
    @apply tw-text-xs tw-font-regular tw-text-text-disable;
  }

  &__chevron {
    @apply tw-text-black;
  }
}
</style>
